import envSchema from "env-schema";
const schema = {
    type: 'object',
    required: ['VUE_APP_API_BASE_URL', 'VUE_APP_ETHERSCAN_API_KEY'],
    properties: {
        VUE_APP_RISK_LOW_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 30
        },
        VUE_APP_RISK_MEDIUM_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 69
        },
        VUE_APP_RISK_HIGH_THRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 100
        },
        VUE_APP_RISK_SCORE_TRESHOLD: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 55
        },
        VUE_APP_RISK_MEDIUM_DEFAULT: {
            type: 'number' ,
            minimum: 0,
            maximum: 100,
            default: 50
        },
        VUE_APP_API_BASE_URL: {
            type: 'string',
            minLength: 2,
            maxLength: 128,
            default: 'https://dev1.glprotocol.com/api/'
        },
        VUE_APP_API_USERS_URL: {
            type: 'string',
            minLength: 2,
            maxLength: 128,
            default: 'https://dev1.glprotocol.com/api/'
        },
        VUE_APP_LABEL_API_URL: {
            type: 'string',
            minLength: 2,
            maxLength: 128,
            default: 'https://common.dev1.glprotocol.com/api-labeling/'
        },
        VUE_APP_DOCUMENT_GENERATOR_URL: {
            type: 'string',
            minLength: 8,
            maxLength: 128,
            default: 'https://pdfgen.dev1.glprotocol.com'
        },
        VUE_APP_COIN_TYPE: {
            type: 'boolean',
            default: false
        },
        VUE_APP_PDF_GENERATOR: {
            type: 'boolean',
            default: false
        },
        VUE_APP_THEME: {
            type: 'string',
            maxLength: 128,
            default: 'default'
        },
        VUE_APP_FIAT_LIST: {
            type: 'string',
            default: '[{"key":"USD","label":"USD"},{"key":"EUR","label":"EUR"}]'
        },
        VUE_APP_FEATURE_PAYMENT: {
            type: 'boolean',
            default: true
        },
        VUE_APP_ESSENTIAL_REPORT: {
            type: 'boolean',
            default: false
        },
        VUE_APP_SCORE_REQUEST_DIRECTION: {
            type: 'number' ,
            default: 2
        },
        VUE_APP_STRIPE_PUBLISHABLE_KEY: {
            type: 'string',
            default: ''
        },
        VUE_APP_ETHERSCAN_API_KEY: {
            type: 'string',
            default: ''
        },
        VUE_APP_FEATURE_CLEAR_ONBOARDING_STATE: {
          type: 'boolean',
          default: false
        },
    }
}

const config = envSchema({
    schema: schema,
    data: process.env, // optional, default: process.env
    dotenv: true // load .env if it is there, default: false
})

export default config
